<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/css/common/base.scss";
@import "@/assets/css/common/reset-element-ui.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue